import { CONDITION_CODES } from '../../../data/conditionCodes';
import { CodeListField } from '../claimWorksheet/CodeListField';

export function ConditionCodesField({
  values,
  onChange,
}: {
  values: string[];
  onChange: (next: string[]) => void;
}) {
  return (
    <CodeListField
      label='Condition Code'
      showLabel={false}
      options={CONDITION_CODES}
      values={values}
      onChange={onChange}
    />
  );
}
